import { FC } from 'react'
import PositionModal from '@modals/PositionModal'
import ModalOnRoute from '@templates/ModalOnRoute'

const PositionModalOnRoute: FC = () => {
  return <ModalOnRoute Component={PositionModal} withoutCloseOnOutsideClick />
}

export default PositionModalOnRoute
